import logo1 from "../../assets/img/historicEvents/LogoOnlysPPV/DTD.png";

export const decemberToDismemberDetail = {
  "december-to-dismember": {
    id: "december-to-dismember",
    title: "December to Dismember",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "december-to-dismember",
        items: [
          {
            id: "december-to-dismember-1",
            title: "December To Dismember",
            description: "You better watch out... 2006",
            imgUrl: logo1,
          },
        ],
      },
    ],
  },
};
